import * as logMessageTypes from '../../consts/app/logMessageTypes';
import cmTimeouts from '../../consts/config/cmTimeouts';
import {makeSelectIotDeviceFullData} from '../../state/selectors/consumer';
import {makeSelectIsDeviceReady} from '../../state/selectors/iotDevice';
import {makeSelectIsYapDeviceConnected, makeSelectIsYapHolderConnected} from '../../state/selectors/yapEncrypted';
import {getState} from '../../state/store';
import helpers from '../../utils/helpers';
import log from '../logger/log';
import DeviceCmClient from './DeviceCmClient';
import HolderCmClient from './HolderCmClient';

const getCmClient = (isHolder) => (id, options) => {
    try {
        const Client = isHolder ? HolderCmClient : DeviceCmClient;

        return new Client(id, options);
    } catch (e) {
        return null;
    }
};

const waitUntilConnected = async (params) => {
    const {isHolder, isCheckDeviceReady = false} = params || {};
    let {timer = cmTimeouts.CM_CONNECT_TIMEOUT} = params || {};

    const state = getState();
    const isYapDeviceConnected = isHolder
        ? makeSelectIsYapHolderConnected()(state)
        : makeSelectIsYapDeviceConnected()(state);
    const isDeviceReady = makeSelectIsDeviceReady()(state);

    if (isYapDeviceConnected && (isDeviceReady || !isCheckDeviceReady)) return true;

    const cmClient = getCmClient(isHolder)();

    if (!cmClient) return false;

    if (--timer < 0) {
        if (isCheckDeviceReady) {
            log.error(
                'CM Client. CONNECTED status does not arrive from yap websocket or device is not ready.',
                logMessageTypes.IOT
            );
        } else {
            log.error('CM Client. CONNECTED status does not arrive from yap websocket.', logMessageTypes.IOT);
        }
        return false;
    }

    await helpers.timeout(1000);
    return await waitUntilConnected({isHolder, timer, isCheckDeviceReady});
};

const getDeviceType = () => {
    const iotProduct = makeSelectIotDeviceFullData()(getState());

    return iotProduct?.device?.type;
};

export default {
    getCmClient,
    getDeviceType,
    waitUntilConnected,
};
